(() => {
  const sections = document.querySelectorAll('[data-recommend-products]');
  if (!sections.length) return;
  if (typeof window.Swiper === 'undefined') return;

  const desktopMediaQuery = window.matchMedia('(min-width: 750px)');

  sections.forEach((section) => {
    const desktopSlider = section.querySelector('[data-recommend-products-slider-desktop]');
    if (!desktopSlider || !desktopMediaQuery.matches) return;

    const desktopCount = Number(desktopSlider.dataset.slideCount) || 0;
    if (desktopCount <= 9) return;

    const desktopWrap = desktopSlider.closest('.recommend-products__slider-wrap');
    new window.Swiper(desktopSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 450,
      navigation: {
        prevEl: desktopWrap.querySelector('[data-recommend-products-prev]'),
        nextEl: desktopWrap.querySelector('[data-recommend-products-next]')
      }
    });
  });
})();
